import { GroupType } from './productCategoryType';

export enum ChargeCodeSource {
  Activate = 'CHARGE_CODE_SOURCE_ACTIVATE',
  Integration = 'CHARGE_CODE_SOURCE_INTEGRATION',
}

export interface ChargeCode {
  id: string;
  chargeCode: string;
  chargeCodeSource: ChargeCodeSource;
  description?: string;
  glCode: string;
  groupId: string;
  groupType: GroupType;
}
